import type { AssignToCaseSelectionLabels } from '../types/assign-to-case';

type TranslateFn = (key: string) => string;

/** Builds the case-selection labels from the `pages.assignToCase` locale keys. */
export const buildCaseSelectionLabels = (
  t: TranslateFn
): AssignToCaseSelectionLabels => ({
  featureTitle: t('pages.assignToCase.title'),
  locationListTitle: t('pages.assignToCase.caseSelection.locationListTitle'),
  caseListTitle: t('pages.assignToCase.caseSelection.caseListTitle'),
  selectButtonLabel: t('pages.assignToCase.caseSelection.selectButton'),
  changeLocationButtonLabel: t(
    'pages.assignToCase.caseSelection.changeLocationButton'
  ),
  viewAllLocationsLabel: t('pages.assignToCase.caseSelection.viewAllLocations'),
  hideAdditionalLocationsLabel: t(
    'pages.assignToCase.caseSelection.hideAdditionalLocations'
  ),
  viewAllCasesLabel: t('pages.assignToCase.caseSelection.viewAllCases'),
  hideAdditionalCasesLabel: t(
    'pages.assignToCase.caseSelection.hideAdditionalCases'
  ),
  noCasesMessage: t('pages.assignToCase.caseSelection.noCases'),
});
